import { createStore as t, asyncAction as n, mutator as r, orchestrator as o, applyMiddleware as e } from "@poa/satcheljs";
import { computed as u } from "mobx";
export * from "mobx";
import { getRouter as i } from "@poa/router";
export * from "mobx-react";
var c = {},
    f = {},
    a = {},
    p = [];

function s() {
  return f;
}

function m() {
  return c;
}

function v() {
  return a;
}

function h() {
  for (var t = [], n = arguments.length; n--;) {
    t[n] = arguments[n];
  }

  p.push.apply(p, t);
}

function x(t) {
  return u(function () {
    return t(m());
  });
}

function b(n) {
  var r;
  return r = t("poaStore", n)(), c = r, m();
}

function y(t, r) {
  return n(t, r);
}

function l(t, n) {
  return r(t, function (t) {
    n(t, {
      store: m()
    });
  });
}

function d(t, n) {
  return o(t, function (t) {
    return n(t, {
      actions: v(),
      env: s(),
      store: m(),
      router: i()
    });
  });
}

var I = y("@@INIT", function () {
  return {};
});

function g(t, n) {
  return new Promise(function (r, o) {
    var u, i, c;
    return u = b(t.state.initial), a = t.state.actions, i = v(), f = t.env, c = s(), n(function (t) {
      t.prototype.store = m(), t.prototype.actions = v(), t.prototype.env = s();
    }), p.forEach(function (t) {
      return e(t(m()));
    }), I().then(function (t) {
      try {
        return r({
          store: u,
          actions: i,
          env: c
        });
      } catch (t) {
        return o(t);
      }
    }.bind(this), o);
  }.bind(this));
}

export { g as boot, I as initAction, y as createAction, l as addMutator, d as addSideEffects, h as addMiddleware, x as selector };